<template>
  <div class="card-form">
    <PageTable
      :loading="loading"
      :tableData="tableData"
      :tablePage="page"
      @reload="reload"
      @checkbox-change="(e) => $emit('checkbox-change', e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />

      <template #toolbar_btn>
        <SortFieldsPopover
          v-model="sortFields"
          funcListName="hxFtyInvInNoticeDetailChooseList"
          style="margin-right: 0.8em;"
          @change="reload"
        />
      </template>
    </PageTable>
  </div>
</template>
<script>
import PageHeader from './header.vue'
import PageTable from './table.vue'
import BaseTable from '@/mixins/base-table'
import SortFieldsPopover from '@/views/ecom/components/sort-fields-popover'
export default {
  mixins: [BaseTable],
  components: { PageTable, PageHeader, SortFieldsPopover },
  props: { scmCode: { type: String, default: '' } },
  data() {
    return { usePage: true, sortFields: [] }
  },
  methods: {
    async getData(form) {
      if (!this.scmCode) return
      this.loading = true
      const params = {
        scmCode: this.scmCode,
        ...form,
        ...this.page,
        sortFields: this.sortFields,
      }
      const res = await this.$api
        .ecomHxFtyNoticeInDetailOptionsApi(params)
        .catch(() => false)
      this.loading = false
      if (!res) return
      this.setData(res)
    },
  },
}
</script>
